var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.1022V17.0189C6 18.4102 7.1279 19.5381 8.51923 19.5381H16.9167C18.308 19.5381 19.4359 18.4102 19.4359 17.0189V8.62143C19.4359 7.23009 18.308 6.1022 16.9167 6.1022H6ZM6 6.1022V5.26245",
    stroke: "#2191F0",
    strokeWidth: 1.25962
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7564 6.10231V6.73212H18.3862V6.10231H17.7564ZM15.8394 3.0172L15.7503 2.39372L15.8394 3.0172ZM6.77222 4.31251L6.68316 3.68903H6.68316L6.77222 4.31251ZM6.89942 6.73212H17.7564V5.47251H6.89942V6.73212ZM18.3862 6.10231V4.6798H17.1266V6.10231H18.3862ZM15.7503 2.39372L6.68316 3.68903L6.86129 4.93599L15.9285 3.64067L15.7503 2.39372ZM6.68316 3.68903C5.92978 3.79665 5.37019 4.44187 5.37019 5.20289H6.62981C6.62981 5.06872 6.72847 4.95496 6.86129 4.93599L6.68316 3.68903ZM18.3862 4.6798C18.3862 3.27448 17.1415 2.19497 15.7503 2.39372L15.9285 3.64067C16.5608 3.55034 17.1266 4.04102 17.1266 4.6798H18.3862ZM6.89942 5.47251C6.75052 5.47251 6.62981 5.3518 6.62981 5.20289H5.37019C5.37019 6.04746 6.05485 6.73212 6.89942 6.73212V5.47251Z",
    fill: "#2191F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35889 11.1406H16.0768",
    stroke: "#2191F0",
    strokeWidth: 1.25962,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35889 14.0797H13.9775",
    stroke: "#2191F0",
    strokeWidth: 1.25962,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.110f278954829869ebe7e9da701d5931.svg";
export { ForwardRef as ReactComponent };